export const INSTATHINK_API_BASE_URL = `${import.meta.env.BUILD_API_BASE_URL}/chat/agent-tool`;
